import { useCallback, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { validDateKey } from "@/shared/utils/calendarDate";

const URL_SYNC_DELAY_MS = 300;

export function useAgendaActiveDay(todayKey: string) {
  const [params, setParams] = useSearchParams();
  const param = params.get("date");
  const [activeKey, setActiveKey] = useState(() => validDateKey(param) ? param : todayKey);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  const selectDay = useCallback((dateKey: string) => {
    setActiveKey(dateKey);
    window.clearTimeout(timer.current);
    // Scrolling reports many days in a row; only the settled one replaces the URL.
    timer.current = window.setTimeout(() => setParams((current) => {
      const next = new URLSearchParams(current);
      next.set("date", dateKey);
      return next;
    }, { replace: true }), URL_SYNC_DELAY_MS);
  }, [setParams]);

  return { activeKey, selectDay };
}
